.shimmerWrapper {
  position: relative;
  overflow: hidden;
  background-color: rgb(var(--ng-neutral-10));
  border-radius: var(--ng-rd-4);
}

.shimmer {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgb(var(--ng-neutral-10)) 0%,
    rgb(var(--ng-neutral-20)) 20%,
    rgb(var(--ng-neutral-10)) 40%,
    rgb(var(--ng-neutral-10)) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}